import { render, staticRenderFns } from "./AntistopList.vue?vue&type=template&id=1e883dec&scoped=true&"
import script from "./AntistopList.vue?vue&type=script&lang=js&"
export * from "./AntistopList.vue?vue&type=script&lang=js&"
import style0 from "./AntistopList.vue?vue&type=style&index=0&id=1e883dec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e883dec",
  null
  
)

export default component.exports